import React, { memo } from 'react';

import { Folder } from '../../../types/Folder';
import { IconType } from '../../../types/IconType';
import { Option } from '../../../types/Option';
import { PilotId } from '../../../types/PilotId';
import { SharedSelectProps } from '../../../types/SharedSelectProps';
import { Select } from '../Select';

interface Props<M> extends SharedSelectProps<PilotId, M> {
  /** Folders that will be available as options. */
  folders: Folder[];
}

export const FolderSelect = memo(
  <M extends boolean>({ folders, onChange, value, ...rest }: Props<M>) => {
    const options = folders.map(
      (f: Folder): Option<PilotId> => ({
        value: f.id,
        label: f.name,
        leftIcon: 'folder' as IconType,
        description: f.path,
        disabled: f.disabled,
      }),
    );

    return (
      <Select
        {...rest}
        options={options}
        placeholder="Search folders…"
        value={value}
        onChange={onChange}
      />
    );
  },
);
